<template>
  <div class="eula-page">
    <div class="eula-shell">
      <!-- 返回 -->
      <div class="eula-topbar" @click="goBack">
        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="m12 19-7-7 7-7" />
          <path d="M19 12H5" />
        </svg>
        返回
      </div>

      <!-- 头部 -->
      <header class="eula-card eula-header">
        <div class="brand-row">
          <img class="brand-logo" src="/static/image/home/brand_logo.png" alt="关盈堂" />
          <span class="brand-name">关盈堂</span>
        </div>
        <h1 class="eula-title">{{ eula.title }}</h1>
        <div class="eula-meta">
          <span class="meta-item"><i class="meta-dot"></i>适用范围：网站 / 公众号 / 小程序等{{ eula.company }}提供的所有系统</span>
        </div>
      </header>

      <!-- 重要提示 -->
      <section class="eula-notice">
        <span class="notice-tag">重要提示</span>
        <p class="notice-text">{{ eula.notice }}</p>
      </section>

      <!-- 正文 -->
      <section class="eula-card eula-body">
        <template v-for="(item, index) in eula.clauses">
          <h2 v-if="item.type === 'h'" :key="'h' + index" class="clause-title">
            <span class="clause-bar"></span>
            <span>{{ item.text }}</span>
          </h2>
          <p v-else-if="item.type === 'sub'" :key="'s' + index" class="clause-sub">{{ item.text }}</p>
          <p v-else-if="item.type === 'item'" :key="'i' + index" class="clause-item">{{ item.text }}</p>
          <p v-else :key="'p' + index" class="clause-text" :class="{ 'is-strong': item.strong }">{{ item.text }}</p>
        </template>
      </section>

      <!-- 底部 -->
      <footer class="eula-footer">
        <p class="footer-company">{{ eula.company }}</p>
        <p class="footer-date">{{ eula.effective }}</p>
      </footer>
    </div>

    <!-- 回到顶部 -->
    <transition name="eula-fade">
      <div v-show="showTop" class="back-top" @click="scrollTop">顶部</div>
    </transition>
  </div>
</template>

<script>
import eula from '@/js/eula.js'

export default {
  name: 'Protocol',
  data() {
    return {
      eula: eula,
      showTop: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.push('/Login')
      }
    },
    onScroll() {
      this.showTop = (window.pageYOffset || document.documentElement.scrollTop) > 480
    },
    scrollTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
.eula-page {
  min-height: 100vh;
  padding: 32px 24px 64px;
  background: radial-gradient(circle at 84% 8%, rgba(200, 169, 110, 0.16), transparent 26%),
    linear-gradient(120deg, #eef8f6 0%, #f9fcfa 50%, #eff8f3 100%);
  font-family: '思源黑体', 'Source Han Sans SC', 'Noto Sans SC', system-ui, sans-serif;
  color: #304744;
  box-sizing: border-box;
}

.eula-shell {
  max-width: 980px;
  margin: 0 auto;
}

/* ===== 返回 ===== */
.eula-topbar {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding: 8px 16px;
  border-radius: 999px;
  border: 1px solid rgba(0, 151, 152, 0.2);
  background: #f3f9f8;
  font-size: 13px;
  font-weight: 500;
  color: #009798;
  cursor: pointer;
  transition: background 0.2s;
}

.eula-topbar:hover {
  background: #e3f3f1;
}

/* ===== 卡片 ===== */
.eula-card {
  background: #ffffff;
  border: 1px solid #d3e6e3;
  border-radius: 24px;
  box-shadow: 0 14px 36px rgba(23, 61, 59, 0.08);
}

/* ===== 头部 ===== */
.eula-header {
  position: relative;
  overflow: hidden;
  padding: 36px 44px 30px;
  text-align: center;
}

.eula-header::before {
  content: '';
  position: absolute;
  inset: 0 0 auto;
  height: 6px;
  background: linear-gradient(90deg, #009798 0%, #0aa9a5 55%, #c8a96e 100%);
}

.brand-row {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
}

.brand-logo {
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.brand-name {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 2px;
  color: #009798;
}

.eula-title {
  margin: 0;
  font-size: 30px;
  font-weight: 700;
  line-height: 1.4;
  letter-spacing: 1px;
  color: #17251f;
}

.eula-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 10px 24px;
  margin-top: 22px;
  padding-top: 20px;
  border-top: 1px dashed #e0ebe8;
}

.meta-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13.5px;
  color: #527f77;
}

.meta-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #0aa9a5;
}

/* ===== 重要提示 ===== */
.eula-notice {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-top: 18px;
  padding: 18px 24px;
  border-radius: 18px;
  border: 1px solid #cfe5e2;
  background: #eaf6f4;
}

.notice-tag {
  flex-shrink: 0;
  padding: 4px 12px;
  border-radius: 999px;
  background: #009798;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
  color: #ffffff;
  line-height: 20px;
}

.notice-text {
  margin: 0;
  font-size: 14.5px;
  line-height: 1.85;
  text-align: justify;
  color: #2f5955;
}

/* ===== 正文 ===== */
.eula-body {
  margin-top: 18px;
  padding: 40px 48px 44px;
}

.clause-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 34px 0 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eef4f2;
  font-size: 19px;
  font-weight: 700;
  line-height: 1.5;
  letter-spacing: 0.5px;
  color: #17251f;
}

.clause-title:first-child {
  margin-top: 0;
}

.clause-bar {
  width: 4px;
  height: 18px;
  border-radius: 4px;
  background: #009798;
}

.clause-sub {
  margin: 22px 0 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.7;
  color: #1f4b47;
}

.clause-text {
  margin: 0 0 14px;
  font-size: 15.5px;
  line-height: 1.95;
  text-align: justify;
  text-indent: 2em;
  letter-spacing: 0.2px;
  color: #304744;
}

.clause-item {
  margin: 0 0 10px;
  padding-left: 1.6em;
  text-indent: -1.6em;
  font-size: 15.5px;
  line-height: 1.95;
  text-align: justify;
  color: #3a5350;
}

.is-strong {
  font-weight: 700;
  color: #1f3b38;
}

/* ===== 底部 ===== */
.eula-footer {
  margin-top: 26px;
  padding-top: 22px;
  border-top: 1px solid rgba(23, 61, 59, 0.1);
  text-align: center;
}

.footer-company {
  margin: 0 0 6px;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 1px;
  color: #304744;
}

.footer-date {
  margin: 0;
  font-size: 13px;
  color: #9aa8a3;
}

/* ===== 回到顶部 ===== */
.back-top {
  position: fixed;
  right: 32px;
  bottom: 48px;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #ffffff;
  border: 1px solid #cfe5e2;
  box-shadow: 0 10px 26px rgba(23, 61, 59, 0.14);
  font-size: 12px;
  font-weight: 600;
  color: #009798;
  cursor: pointer;
  transition: transform 0.2s, background 0.2s;
  z-index: 20;
}

.back-top:hover {
  background: #eaf6f4;
  transform: translateY(-2px);
}

.eula-fade-enter-active,
.eula-fade-leave-active {
  transition: opacity 0.2s;
}

.eula-fade-enter,
.eula-fade-leave-to {
  opacity: 0;
}

/* ===== 响应式 ===== */
@media (max-width: 768px) {
  .eula-page {
    padding: 16px 12px 40px;
  }

  .eula-header {
    padding: 28px 20px 24px;
  }

  .eula-title {
    font-size: 24px;
  }

  .eula-body {
    padding: 26px 20px 30px;
  }

  .eula-notice {
    flex-direction: column;
    gap: 10px;
    padding: 16px 18px;
  }

  .back-top {
    right: 16px;
    bottom: 24px;
  }
}
</style>
